const isLocalBuild = process.env.NODE_ENV === 'production' && !window.location.host.includes('dalaledstang.se');
const host = isLocalBuild ? 'https://staging.dalaledstang.se' : '';

export default function asset(path) {
  return host + path;
}



// WEBPACK FOOTER //
// ./src/assetLoader.js